module.exports = __webpack_public_path__ + "img/havefun_title-kr.bafd6552.png";